import { render } from "./StudyHeader.vue?vue&type=template&id=509f7800&scoped=true&ts=true"
import script from "./StudyHeader.ts?vue&type=script&lang=ts"
export * from "./StudyHeader.ts?vue&type=script&lang=ts"

import "./StudyHeader.scss?vue&type=style&index=0&id=509f7800&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1675282552/src/codestar-connections.eu-west-1.amazonaws.com/git-http/637423592620/eu-west-1/d1c24b47-9e0d-4a51-af9e-d1114251523b/studyportals/WishlistButton/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-509f7800"]])

export default __exports__